// extracted by mini-css-extract-plugin
module.exports = {"icon":"profile-menu_icon__9aCXv","text":"profile-menu_text__KWXHT","activeText":"profile-menu_activeText__NY_4Z","arrow":"profile-menu_arrow__2pfuc"};